import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './BottomNav.css';
import { useAuth } from '../context/AuthContext.js';

function BottomNav() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const userRole = user?.role || 'athlete';

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  // Admin/coach: 5 thumb-reachable essentials; everything else lives under "More"
  // (src/components/More.js is a role-filtered overflow hub).  A crowded bottom
  // bar is hard to use rink-side, so secondary tools intentionally move to More.
  const adminCoachItems = [
    { path: '/video',    icon: '🎥', label: 'Record'   },  // was /record (redirects to /video)
    { path: '/athletes', icon: '👥', label: 'Athletes' },
    { path: '/calendar', icon: '🗓', label: 'Schedule' },
    { path: '/stats',    icon: '📊', label: 'Stats'    },
    { path: '/more',     icon: '⋯',  label: 'More'     },
  ];

  const parentItems = [
    { path: '/',                icon: '🏠', label: 'Home'     },
    { path: '/calendar',        icon: '🗓', label: 'Schedule' },
    { path: '/parent/invoices', icon: '💳', label: 'Payments' },
    { path: '/profile',         icon: '👤', label: 'Profile'  },
  ];

  const athleteItems = [
    { path: '/',         icon: '🏠', label: 'Home'     },
    { path: '/video',    icon: '🎥', label: 'Record'   },
    { path: '/stats',    icon: '📊', label: 'Stats'    },
    { path: '/calendar', icon: '🗓', label: 'Schedule' },
    { path: '/profile',  icon: '👤', label: 'Profile'  },
  ];

  let items;
  if (userRole === 'admin' || userRole === 'coach') {
    items = adminCoachItems.filter(i => !i.adminOnly || userRole === 'admin');
  } else if (userRole === 'parent') {
    items = parentItems;
  } else {
    items = athleteItems;
  }

  return (
    <nav className="bottom-nav">
      {items.map((item) => (
        <button
          key={item.path}
          onClick={() => navigate(item.path)}
          className={`bottom-nav-item ${isActive(item.path) ? 'active' : ''}`}
        >
          <span className="bottom-nav-icon">{item.icon}</span>
          <span className="bottom-nav-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}

export default BottomNav;
